import fetch from 'fetch'
import _ from 'lodash'

/**
 * subjectType：9 - 支付统一订单 其他取值还会有充值等，前端暂且不考虑
 * paymentAmount：
 * subjectId：
 * paymentType：
 * alipayUserId：仅支付宝使用
 * @param {object} parmas
 */
const unifiedPay = (params) => {
  return new Promise((resolve, reject) => {
    fetch({
      method: 'POST',
      url: `/v1/unifiedPay/pay`,
      data: params
    })
      .then((data) => {
        const { errorHint } = data
        if (errorHint) {
          reject(errorHint)
        } else {
          resolve(data)
        }
      })
      .catch(reject)
  })
}


const payOrder = (params) => {
  return unifiedPay(_.merge({}, params, {
    subjectType: 9
  }))
}

const banmaMakeOrder = (data) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: '/v1/zebra/makeOrder',
      method: 'POST',
      data: data
    }).then((data) => {
      const { hint } = data
      if (hint) {
        reject(hint)
      } else {
        resolve(data)
      }
    }).catch((error) => reject(error))
  })
}

const banmaGetOrderId = (data) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/v1/zebra/${data}/zebraOrderId`,
      method: 'GET'
    }).then((data) => {
      const { hint } = data
      if (hint) {
        reject(hint)
      } else {
        resolve(data)
      }
    }).catch((error) => reject(error))
  })
}

export default {
  payOrder,
  unifiedPay,
  banmaMakeOrder,
  banmaGetOrderId
}



// WEBPACK FOOTER //
// ./src/mods/service/order.js